/* eslint-disable @typescript-eslint/no-explicit-any */
/* TODO: Fix me */
/* eslint-disable max-statements */

/* eslint-disable max-lines-per-function */
/* eslint max-lines: 0 */
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AssetCommand } from '@api/model/assetCommand';
import { AssetProperty } from '@api/model/assetProperty';
import { AssetTelemetry } from '@api/model/assetTelemetry';
import { Navigate } from '@ngxs/router-plugin';
import { ofActionSuccessful } from '@ngxs/store';
import { Observable } from 'rxjs';
import { filter, take, tap } from 'rxjs/operators';
import { GetDcmMenu, SetCapabilityModelUi } from 'src/app/asset-details/asset-capability-state/asset-capability.action';
import { AssetCapabilityState } from 'src/app/asset-details/asset-capability-state/asset-capability.state';
import { ExecuteCommand } from 'src/app/asset-details/asset-commands-state/asset-commands.actions';
import { AssetCommandsState } from 'src/app/asset-details/asset-commands-state/asset-commands.state';
import { GetLastKnownAssetTelemetryValues, GetPropertyValues, PushProperty, SetPropertyValues } from 'src/app/asset-details/asset-property-state/asset-properties.actions';
import { AssetPropertiesState } from 'src/app/asset-details/asset-property-state/asset-properties.state';
import { LoadAssetCapabilityModel, LoadAssetCapabilityModelUserInterface, LoadAssetDetails } from 'src/app/asset-details/asset-selected-state/asset-selected.actions';
import { IAssetOrAnalyticsDetails } from 'src/app/asset-groups/models/asset-details';
import { AssetSelectedState } from '../../../asset-details/asset-selected-state/asset-selected.state';
import { DeactivationGuard } from '../../services/deactivation-guard/deactivation-guard.service';
import { CommandSelectedEvent } from '../commands-properties/command-selected-event';
import { ComponentBaseDirective, IAllowRealTimeUpdates } from '../component.base';
import { ConfirmationButton, IConfirmationButton } from '../confirmation-modal/confirmation-button';
import { getCancelButton } from '../confirmation-modal/confirmation-buttons-repository';
import { IExtendedControl } from '../properties/models/IExtendedControl';
import { PropertiesComponent } from '../properties/properties.component';
import { IContent, IMenuModel } from './models/IMenuModel';
import { PropertiesOverview } from './properties-overview';
import { RoleMenu, RoleMenuSet } from './role-menu-select/roleMenu';

@Component({
    selector: 'app-properties-overview',
    templateUrl: './properties-overview.component.html',
    styleUrls: ['./properties-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PropertiesOverviewComponent extends ComponentBaseDirective implements OnInit, AfterViewInit, OnDestroy, DeactivationGuard, IAllowRealTimeUpdates {
    private changeDetectorRef = inject(ChangeDetectorRef);
    private activatedRoute = inject(ActivatedRoute);
    private router = inject(Router);

    private deviceId: string;
    private assetId: string;
    private startMenuInterval: number;
    private activeMenuId: string;
    private assetDetails: IAssetOrAnalyticsDetails;

    public selectedRole: string;
    public menus$: Observable<IMenuModel[]> = this.store.select(AssetCapabilityState.getMenus);
    public isIOLinkDevice$: Observable<string> = this.store.select(AssetCapabilityState.getDeviceType);
    public assetPropertyValues$: Observable<AssetProperty[]> = this.store.select(AssetPropertiesState.getPropertyValues);
    public lastKnownTelemetryValues$: Observable<AssetTelemetry[]> = this.store.select(AssetPropertiesState.getLastKnownTelemetryValues);
    public isSelectedAssetOffline$: Observable<boolean> = this.store.select(AssetSelectedState.getIsAssetOffline);
    public isCommandExecuting$: Observable<{ [name: string]: boolean }> = this.store.select(AssetCommandsState.getIsCommandExecuting);
    public commandErrors$ = this.store.select(AssetCommandsState.getCommandErrors);
    public assetId$: Observable<string> = this.store.select(AssetSelectedState.getAssetId);
    @ViewChild(PropertiesComponent) public propertiesComponent: PropertiesComponent;

    public get menus() {
        return PropertiesOverview.menus;
    }

    public hasRole = false;
    public assetProperties: IContent[];
    public assetCommands: IContent[];
    public assetTelemetries: IContent[];
    public propertyValues: AssetProperty[];
    public changedPropertyValues: any = {};
    public propertyControls: { [key: string]: IExtendedControl } = {};
    public hierarchyPath: string;

    constructor() {
        super();
    }

    public ngAfterViewInit(): void {
        this.subscribeRouteData();
    }

    private subscribeRouteData() {
        this.subscription.add(
            this.activatedRoute.data
                .pipe(
                    take(1),
                    tap(({ assetDetails }) => {
                        this.assetDetails = assetDetails;
                        this.deviceId = this.assetDetails.deviceId;
                        this.assetId = this.assetDetails.id;

                        this.store.dispatch(new LoadAssetCapabilityModelUserInterface(this.deviceId, this.assetId));
                        this.store.dispatch(new GetPropertyValues());
                        this.store.dispatch(new GetLastKnownAssetTelemetryValues());

                        this.startRealTimeUpdates();
                    })
                )
                .subscribe()
        );
    }

    public ngOnInit() {
        this.subscription.add(
            this.menus$.subscribe((result) => {
                PropertiesOverview.generateIds(result);
                PropertiesOverview.menus = result;
            })
        );

        this.ofActionCompleted(() => {
            this.navigate();
        }, GetLastKnownAssetTelemetryValues);

        this.ofActionSuccessful(() => {
            this.store.dispatch(new GetDcmMenu(this.selectedRole));
        }, SetCapabilityModelUi);

        this.subscription.add(
            this.assetPropertyValues$.subscribe((values) => {
                if (values?.length > 0) {
                    this.propertyValues = [...values];
                    this.changeDetectorRef.detectChanges();
                }
            })
        );

        this.addLoader('properties-overview-loader', LoadAssetCapabilityModel, LoadAssetCapabilityModelUserInterface, GetPropertyValues, GetLastKnownAssetTelemetryValues);
        this.addLoader('asset-details-loader', LoadAssetDetails, GetDcmMenu, GetPropertyValues, SetPropertyValues, GetLastKnownAssetTelemetryValues);

        this.addErrorNotificationWithLanguageKey({ key: 'properties.notifications.setPropertyValuesFailed' }, SetPropertyValues);
        this.addSuccessNotificationWithLanguageKey({ key: 'commands.notifications.executeCommandSucceed' }, ExecuteCommand);
        this.addErrorNotificationWithLanguageKey({ key: 'commands.notifications.executeCommandFailed' }, ExecuteCommand);
    }

    private navigate() {
        var menuHashIndex = location.hash?.indexOf('--') ?? -1;
        this.activeMenuId = menuHashIndex > 0 ? location.hash.substring(menuHashIndex + 2) : null;

        const selectRoleMenu = location.hash.substring(1, location.hash.indexOf('--')) + 'RoleMenuSet';
        const hasRole = RoleMenu.some((r) => r.value === selectRoleMenu);
        if (hasRole) {
            this.selectedRole = selectRoleMenu;
        } else {
            this.selectedRole = RoleMenuSet.Specialist;
        }

        this.selectRoleMenu(this.selectedRole);

        this.subscription.add(
            this.actions$
                .pipe(
                    ofActionSuccessful(GetDcmMenu),
                    filter(() => this.menus?.length > 0)
                )
                .subscribe(() => {
                    var menuHashIndex = location.hash?.indexOf('--') ?? -1;
                    let startMenuId = menuHashIndex > 0 ? location.hash.substring(menuHashIndex + 2) : null;
                    if (!startMenuId?.length) {
                        startMenuId = this.menus[0].id;

                        const identificationMenu = this.menus.find((m) => m.id === 'identification');
                        if (identificationMenu != null) {
                            // if we do have a identification menu we use that as the start point
                            startMenuId = identificationMenu.id;
                        }
                    }

                    let tries = 0;

                    this.startMenuInterval = setInterval(() => {
                        if (tries >= 20) {
                            // break after trying for 5 seconds
                            clearInterval(this.startMenuInterval);
                        }

                        const node = document.querySelector(`[role='${this.selectedRole}'] #${startMenuId}_node`);
                        if (node != null) {
                            this.onMenuItemClick(startMenuId);
                            clearInterval(this.startMenuInterval);
                        }

                        tries++;
                    }, 100) as unknown as number;
                })
        );
    }

    public ngOnDestroy() {
        super.ngOnDestroy();

        if (this.startMenuInterval != null) {
            clearInterval(this.startMenuInterval);
        }
    }

    public async canDeactivate(): Promise<boolean> {
        const dirtyControls = Object.values(this.propertyControls).filter((control) => control?.dirty);

        if (dirtyControls?.length) {
            const confirmationMessage = this.translationService.translate('properties.confirmationDialog.unsavedChangesDialogMessage');

            try {
                const result = await this.confirmationModalService.openUnsavedChanges(this.translationService.translate('defaults.confirmationDialog.unsavedChangesDialogTitle'), confirmationMessage);

                if (result === 'SaveChanges') {
                    this.saveProperties();
                    return true;
                } else if (result === 'DiscardChanges') {
                    return true;
                } else if (result === 'Cancel') {
                    return false;
                } else {
                    return false;
                }
            } catch {
                return false;
            }
        }
        return true;
    }

    public async saveProperties() {
        const invalidControls = Object.values(this.propertyControls).filter((control) => control?.invalid);

        if (invalidControls?.length) {
            this.notificationsService.error(this.translationService.translate('properties.notifications.savePropertiesFailed'));
            return;
        }

        const needsConfirmation = Object.keys(this.changedPropertyValues).some((propertyKey) => this.propertyControls[propertyKey]?.needsConfirmation);

        this.propertiesComponent.resetDirtyState();

        this.subscription.add(
            this.store.dispatch(new SetPropertyValues(this.changedPropertyValues)).subscribe(() => {
                const referencedEntities = this.store.selectSnapshot(AssetPropertiesState.getReferencedEntities);

                if (!referencedEntities?.length) {
                    this.notificationsService.success(this.translationService.translate('properties.notifications.savePropertiesSucceed'));
                    this.resetPropertiesState(needsConfirmation);

                    return;
                }

                const confirmationMessage = this.translationService.translate('properties.confirmationDialog.savePropertiesMessage');
                const confirmationButtons = this.getConfirmationButtons();

                this.confirmationModalService.openCallback(this.translationService.translate('properties.confirmationDialog.saveProperties'), confirmationMessage, confirmationButtons, undefined, true, (confirmationModalRef) => {
                    confirmationModalRef.confirmationModalComponent.deleteReferencedEntities.set(referencedEntities);

                    this.subscribe(confirmationModalRef.buttonClicked, (result) => {
                        if (result === true) {
                            this.forceSaveProperties();
                        }
                    });
                });
            })
        );
    }

    public async startRealTimeUpdates() {
        await this.startRealTime(this.assetId, 'Property', PushProperty);
    }

    public async stopRealTimeUpdates() {
        await this.stopRealTime(this.assetId, 'Property', PushProperty);
    }

    public selectRoleMenu(selectedRole: string) {
        if (this.hasRole) {
            this.activeMenuId = null;
        }

        this.hasRole = true;
        this.assetProperties = null;
        this.assetCommands = null;
        this.resetChangedProperties();
        this.selectedRole = selectedRole;
        this.updateUrlFragment();

        this.changeDetectorRef.detectChanges();

        this.store.dispatch(new GetDcmMenu(this.selectedRole));
    }

    public toggle(menuId: string) {
        return PropertiesOverview.toggle(menuId);
    }

    public getToggleState(elementId: string): boolean {
        return PropertiesOverview.getToggleState(elementId);
    }

    public onMenuItemClick(menuId: string) {
        let menu = PropertiesOverview.ids.get(menuId);

        const treeNodes = Array.from(document.getElementsByClassName('tree-node'));
        for (const treeNode of treeNodes) {
            treeNode.classList.remove('properties-tree-item-selected');
        }

        const selectedNode = document.getElementById(menuId + '_node');
        if (!selectedNode) {
            return false;
        }

        document.getElementById(menuId)?.setAttribute('value', 'true');

        // check if the current menu has content
        // if not we try to get the next sub menu that has content
        if (menu.contents?.length == 0 && menu.submenus.length > 0) {
            const submenu = menu.submenus.find((s) => s.contents?.length > 0);
            if (submenu != null) {
                const hasValues = this.onMenuItemClick(submenu.id);
                if (hasValues) {
                    // if our submenus have content we stop here otherwise we display the empty menu
                    return true;
                }
            }
        }

        this.hierarchyPath = selectedNode.getAttribute('hierarchyPath');
        selectedNode.classList.add('properties-tree-item-selected');

        this.expandNodesInHierarchyPath();

        this.activeMenuId = menuId;

        this.updateUrlFragment();

        if (menu.contents?.length > 0) {
            this.assetProperties = menu.contents.filter((c) => c['@type'] === 'Property');
            this.assetCommands = menu.contents.filter((c) => c['@type'] === 'Command');
            this.assetTelemetries = menu.contents.filter((c) => c['@type'] === 'Telemetry');
        } else {
            this.assetProperties = null;
            this.assetCommands = null;
            this.assetTelemetries = null;
        }

        this.changeDetectorRef.detectChanges();
        return menu.contents?.length > 0;
    }

    private expandNodesInHierarchyPath() {
        for (const menuId of this.hierarchyPath.split('/')) {
            if (!menuId.length) {
                continue;
            }

            document.getElementById(menuId)?.setAttribute('value', 'true');
        }
    }

    public onPropertyChanged() {
        const propertyValues = this.propertiesComponent.values;

        for (const nodeId of this.hierarchyPath.split('/')) {
            if (!nodeId.length) {
                continue;
            }

            if (Object.keys(propertyValues).length) {
                const node = document.getElementById(nodeId + '_node');
                node.classList.add('properties-tree-item-property-changed');
            }
        }

        for (const key of Object.keys(propertyValues)) {
            const value = propertyValues[key as keyof typeof propertyValues] as any;
            this.changedPropertyValues[key] = value?.toString();
        }

        // patch cached changes into data from store to persist changed values over navigation between different menues.
        if (this.propertyValues?.length) {
            for (const change of Object.keys(propertyValues)) {
                const propIndex = this.propertyValues.findIndex((p) => p.name === change);
                const prop = { ...this.propertyValues[propIndex] };
                prop.desiredValue = propertyValues[change as keyof typeof propertyValues];
                this.propertyValues[propIndex] = prop;
            }
        }

        const propertyControls = this.propertiesComponent.form.controls;
        for (const key of Object.keys(propertyControls)) {
            this.propertyControls[key] = propertyControls[key] as IExtendedControl;
        }

        const hasChangedValues = Object.keys(this.changedPropertyValues).length !== 0;
        if (!hasChangedValues) {
            this.resetChangedProperties();
        }
    }

    public resetChangedProperties() {
        this.changedPropertyValues = {};
        this.propertyControls = {};

        const treeNodes = Array.from(document.getElementsByClassName('tree-node'));
        for (const element of treeNodes) {
            const node = element as HTMLElement;
            node.classList.remove('properties-tree-item-property-changed');
        }

        if (this.propertiesComponent) {
            this.changeDetectorRef.detectChanges();
        }
    }

    public async executeCommand(commandValue: CommandSelectedEvent) {
        const name = commandValue.name;
        const parameters = commandValue.parameters;
        const success = await this.confirmationModalService.openDefaultConfirmation(
            this.translationService.translate('commands.confirmationDialog.executeCommand'),
            this.translationService.translate('commands.confirmationDialog.executeCommandMessage')
        );

        if (!success) {
            return;
        }

        const command = { name, parameters } as AssetCommand;
        this.store.dispatch(new ExecuteCommand(command));
    }

    private getConfirmationButtons(): IConfirmationButton[] {
        const confirmationButtons = [new ConfirmationButton(this.translationService, 'delete-all', 'actions.deleteAll', true, ['btn', 'confirmation-modal-warning-button']), getCancelButton(this.translationService)] as IConfirmationButton[];
        confirmationButtons[0].setDelay(5);

        return confirmationButtons;
    }

    private forceSaveProperties() {
        this.subscribe(this.store.dispatch(new SetPropertyValues(this.changedPropertyValues, true)), () => {
            this.notificationsService.success(this.translationService.translate('properties.notifications.savePropertiesSucceed'));
            this.resetPropertiesState(true);
        });

        this.confirmationModalService.close();
    }

    private resetPropertiesState(needsConfirmation: boolean) {
        this.resetChangedProperties();
        this.propertiesComponent.resetDirtyState();

        if (needsConfirmation) {
            this.store.dispatch(new Navigate([`/devices/${this.deviceId}`]));
        }
    }

    private updateUrlFragment() {
        const role = this.selectedRole.replace('RoleMenuSet', '');

        let fragment = role;
        if (this.activeMenuId != null) {
            fragment = `${role}--${this.activeMenuId}`;
        }

        this.router.navigate([], {
            fragment: fragment,
        });
    }
}
